import { render, staticRenderFns } from "./WeightHistoryDiffChart.vue?vue&type=template&id=0ea4fc82&scoped=true&"
import script from "./WeightHistoryDiffChart.vue?vue&type=script&lang=js&"
export * from "./WeightHistoryDiffChart.vue?vue&type=script&lang=js&"
import style0 from "./WeightHistoryDiffChart.vue?vue&type=style&index=0&id=0ea4fc82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea4fc82",
  null
  
)

export default component.exports